import React from 'react';
import PropTypes from 'prop-types';
import DamProgeny from './dam/DamProgeny';
import ProgenyCommon from './components/ProgenyCommon';

const Progeny = ({
    data: {
        progenyResults,
        availableSeasonsData,
        progenyHorsesData,
        profile: { damStatus, weatherbysUid },
    }, params: { id, tab },
}) => (
    (!tab || tab === 'progeny') && damStatus ? (
        <DamProgeny data={progenyResults} />
    ) : (
        <ProgenyCommon
            id={id}
            weatherbysUid={weatherbysUid}
            availableSeasonsData={availableSeasonsData}
            data={progenyHorsesData.data}
            tab={tab}
        />
    )
);

Progeny.propTypes = {
    data: PropTypes.shape({
        progenyResults: PropTypes.shape({
            FLAT: PropTypes.arrayOf(PropTypes.shape({ horseUid: PropTypes.number })),
            JUMPS: PropTypes.arrayOf(PropTypes.shape({ horseUid: PropTypes.number })),
        }),
        profile: PropTypes.shape({
            damStatus: PropTypes.bool,
            weatherbysUid: PropTypes.string,
        }),
        progenyHorsesData: PropTypes.shape({
            data: PropTypes.shape({
                progenyHorses: PropTypes.arrayOf(PropTypes.shape({})),
                seasonInfo: PropTypes.shape({}),
            }),
        }),
        availableSeasonsData: PropTypes.shape({
            data: PropTypes.shape({
                FLAT: PropTypes.arrayOf(PropTypes.shape({
                    seasonStartYear: PropTypes.string,
                    seasonEndYear: PropTypes.string,
                })),
                JUMPS: PropTypes.arrayOf(PropTypes.shape({
                    seasonStartYear: PropTypes.string,
                    seasonEndYear: PropTypes.string,
                })),
            }),
        }),
    }).isRequired,
    params: PropTypes.shape({
        id: PropTypes.string,
        tab: PropTypes.string,
    }),
};

export default Progeny;



// WEBPACK FOOTER //
// ./src/js/horse/progeny/Progeny.jsx